import React, { Component } from 'react';

import {Confirm, ConfirmTC} from './Confirm.js';


class ConfirmContainer extends Component {
    constructor(props) {
        super(props);
        this.initialState = {};
        this.state = this.initialState;
        this.onComplete = this.onComplete.bind(this);
    }
    onComplete() {
        if(this.props.onComplete) {
            this.props.onComplete({});
        }
    }
    render() {
        var challenge = this.props.challenge;
        var ConfirmView = this.props.teamChallengeData ? ConfirmTC : Confirm;
        return <ConfirmView {...this.props}
                   challenge={challenge}
                   onComplete={this.onComplete}
                   completePending={this.props.completePending}
                   />;
    }

}

export default ConfirmContainer;



// WEBPACK FOOTER //
// ./src/modules/challenges/types/screens/ConfirmContainer.js